import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
import type { AppDispatch } from '../index'
import { RootState } from '../slices/reducers'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export { useLandsFavorites } from './useLandsFavorites'
export { useBuildingsFavorites } from './useBuildingsFavorites'
export { useEnhancedFavorites } from './useEnhancedFavorites'
export { useBuildingTags } from './useBuildingTags'
export { useLandFilters } from './useLandFilters'
